import { makeStyles, fade } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },

  disabled: {
    color: 'rgba(0, 0, 0, 0.38) !important',
  },
  schedulestrip: {
    backgroundColor: 'rgba(151,151,151,0.1)',
    borderRadius: 5,
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  timedatecol: {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    borderRight: '1px solid #4860CF',
  },
  col: {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
  time: {
    color: '#353755',
    fontSize: 18,
    margin: theme.spacing(0),
    textAlign: 'right',
    lineHeight: '18px',
  },
  date: {
    color: '#353755',
    fontSize: 12,
    margin: theme.spacing(0),
    textAlign: 'right',
  },
  cycling: {
    color: '#4D507B',
    fontSize: 18,
    margin: theme.spacing(0),
    display: 'flex',
    lineHeight: '18px',
  },
  icon: {
    marginRight: theme.spacing(1),
  },
  midtown: {
    color: '#4D507B',
    fontSize: 18,
    margin: theme.spacing(0),
    display: 'flex',
    lineHeight: '20px',
  },
  instructor: {
    color: '#4D507B',
    fontSize: 18,
    fontWeight: 700,
    margin: theme.spacing(0),
  },
  label: {
    color: '#4D507B',
    fontSize: 18,
    fontWeight: 400,
  },
  cancelbtn: {
    padding: '5px',
    width: '120px',
    float: 'right',
  },
  addclassbtn: {
    padding: '5px',
    width: '120px',
    float: 'right',
  },
  filterstrip: {
    backgroundColor: '#F1F2F2',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1),
    },
  },
  filterbytext: {
    fontSize: 16,
    fontWeight: 700,
    color: '#353755',
  },
  filters: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 16,
    fontWeight: 400,
    color: '#353755',
    padding: '8px 10px',
    borderRadius: '30px',
    textTransform: 'none',
    transition: 'all 0.5s ease',
    margin: '0 10px',
    [theme.breakpoints.down('sm')]: {
      margin: '0 4px',
    },
    '&:hover, &.active': {
      backgroundColor: 'rgba(72,96,207,0.39)',
    },
  },
  filtericon: {
    marginRight: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      marginRight: theme.spacing(0),
    },
  },
  clearfilterbtn: {
    padding: '5px 20px',
    [theme.breakpoints.down('sm')]: {
      padding: '10px 10px',
    },
  },
  calendardate: {
    fontSize: 18,
    fontWeight: 400,
    color: '#4860CF',
    // margin: '-5px 0 0 0',
    display: 'flex',

    '& .MuiInput-underline:before': {
      display: 'none',
    },
    '& .MuiInput-underline:after': {
      display: 'none',
    },
    '& .MuiInputBase-input': {
      color: '#4860CF',
      width: 207,
      cursor: 'pointer',
      [theme.breakpoints.down('xs')]: {
        fontSize: 16,
        width: 190,
      },
    },
  },
  leftArrow: {
    fontSize: 40,
    color: '#4860cf',
    cursor: 'pointer',
    [theme.breakpoints.down('xs')]: {
      fontSize: 30,
    },
  },
  rightArrow: {
    fontSize: 40,
    color: '#4860cf',
    cursor: 'pointer',
    [theme.breakpoints.down('xs')]: {
      fontSize: 30,
    },
  },
  col1: {
    position: 'relative',
    backgroundColor: 'rgba(151,151,151,0.1)',
    margin: theme.spacing(0.3),
    padding: theme.spacing(1),
    minHeight: '135px',
    /* width: 135, // added by Faisal */
    color: '#353755',
    transition: 'all 0.5s ease',
    '&.even': {
      backgroundColor: 'rgba(163,175,231,0.27)',
    },
    '&:hover:not(.no-hover),&.active': {
      backgroundColor: '#4860CF',
      color: '#fff',
      cursor: 'pointer',
      '& $signupbtn': {
        opacity: 1,
      },
    },
    [theme.breakpoints.down('md')]: {
      maxHeight: '105px',
    },
    [theme.breakpoints.down('sm')]: {
      minHeight: '135px',
      width: '33.33%',
      minWidth: '33.33%',
      display: 'flex',
      marginRight: 'auto',
      marginLeft: 'auto',
      border: '5px solid #fff',
      margin: '0',
    },
  },
  col2: {
    backgroundColor: 'rgba(163,175,231,0.27)',
    margin: theme.spacing(0.3),
    padding: theme.spacing(1),
    minHeight: '135px',
    width: 135, // added by Faisal
    color: '#353755',
    transition: 'all 0.5s ease',
    '&:hover': {
      backgroundColor: '#4860CF',
      color: '#fff',
    },
    '& $signupbtn': {
      display: 'flex',
    },
  },
  colselect: {
    backgroundColor: '#4860CF',
    margin: theme.spacing(0.3),
    padding: theme.spacing(1),
    minHeight: '142px',
    color: '#fff',
  },
  calweek: {
    fontSize: 18,
    fontWeight: 700,
    color: '#4D507B',
    marginRight: theme.spacing(1),
  },
  caldate: {
    fontSize: 16,
    fontWeight: 400,
    color: '#353755',
  },
  caltitle: {
    fontSize: 14,
    fontWeight: 700,
    lineHeight: '18px',
    marginBottom: theme.spacing(1),
    /* added by Faisal K - start */
    /*  whiteSpace: 'nowrap', */
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: 120,
    maxHeight: 38,
    /* added by Faisal K - end */
    [theme.breakpoints.down('md')]: {
      width: 70,
      maxHeight: 38,
    },
    [theme.breakpoints.down('sm')]: {
      width: 110,
    },
    [theme.breakpoints.down('xs')]: {
      width: 87,
    },
  },
  caltime: {
    fontSize: 11, // modified by FaisalK
    fontWeight: 400,
    marginBottom: theme.spacing(1),
    /* [theme.breakpoints.down('md')]: {
      display: 'none',
    }, */
  },
  calname: {
    fontSize: 11, // modified by FaisalK
    fontWeight: 400,
    marginBottom: theme.spacing(1),
    /* added by Faisal K - start */
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: 119,
    /* added by Faisal K - end */
    [theme.breakpoints.down('md')]: {
      width: 80,
    },
  },
  caldetail: {
    fontSize: 11, // modified by FaisalK
    fontWeight: 400,
    /* marginBottom: theme.spacing(1), */
    /* added by Faisal K - start */
    /* whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis', */
    width: 119,
    /* added by Faisal K - end */
    [theme.breakpoints.down('md')]: {
      width: 80,
    },
  },
  signupbtn: {
    background: '#fff',
    color: '#4860CF',
    fontSize: 12,
    fontWeight: 700,
    padding: '5px 30px',
    margin: '0 auto',
    opacity: 0,

    display: 'flex',
    '&:hover': {
      background: '#fff',
      color: '#4860CF',
    },

    '&:disabled': {
      background: '#fff !important',
      color: '#4860CF !important',
      cursor: 'not-allowed !important',
      pointerEvents: 'all !important',
    },
  },
  modalcancelbtn: {
    fontSize: 14,
    fontWeight: 700,
    color: '#4860CF',
    [theme.breakpoints.down('xs')]: {
      fontSize: '12px',
    },
  },
  btn: {
    padding: '8px 30px',
    color: '#4860CF',
  },
  savebtn: {
    padding: '8px 40px',
  },
  createnewbtn: {
    color: '#4860CF',
    fontSize: 16,
    display: 'flex',
    alignItems: 'center',
    textTransform: 'none',
  },
  days: {
    display: 'none',
    '& + .MuiFormControlLabel-label': {
      background: '#fff',
      border: '1px solid #4860CF',
      color: '#4860CF',
      fontSize: 14,
      padding: '7px 30px',
      borderRadius: '25px',
      margin: '5px',
      transition: 'all 0.5s ease',
      /* '&:hover': {
        background: '#4860CF',
        color: '#fff',
      }, */
    },
  },
  daysselected: {
    display: 'none',
    '& + .MuiFormControlLabel-label': {
      background: '#4860CF !important',
      border: '1px solid #4860CF',
      color: '#fff',
      fontSize: 14,
      padding: '7px 30px',
      borderRadius: '25px',
      margin: '5px',
    },
  },
  daysofweek: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      margin: theme.spacing(0),
      width: 'auto',
      border: '1px solid #979797',
      borderRadius: '25px',
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#979797',
  },
  inputRoot: {
    color: 'inherit',
    width: '100%',
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px) !important`,
    transition: theme.transitions.create('width'),
    width: '100% !important',
    fontSize: '14px !important',
    color: '#8C97B2 !important',
    [theme.breakpoints.up('md')]: {
      width: '100% !important',
    },
  },
  filtertitleblock: {
    margin: theme.spacing(0),
    display: 'flex',
    justifyContent: 'space-between',
  },
  filtertitle: {
    fontSize: 12,
    fontWeight: 700,
    color: '#8C97B2',
  },
  allnoneblock: {
    fontSize: 12,
    fontWeight: 400,
    color: '#4860CF',
    '& span': {
      cursor: 'pointer',
    },
  },
  divider: {
    borderRight: '1px solid #979797',
    paddingRight: '5px',
    marginRight: '5px',
  },
  checkblock: {
    '& .MuiFormControlLabel-label': {
      fontSize: 14,
      fontWeight: 400,
      color: '#8C97B2',
    },
    '& .MuiTypography-root': {
      fontSize: 14,
      fontWeight: 400,
      color: '#8C97B2',
    },
    '& .MuiButtonBase-root': {
      padding: '0',
      margin: '0 9px',
    },
  },
  filterpopover: {
    '& .MuiPaper-elevation8': {
      width: 275,
      maxHeight: 278,
    },
  },
  timePeriodPopover: {
    '& .MuiPaper-elevation8': {
      width: 450,
      maxHeight: 450,
    },
    '& .MuiPickersCalendarHeader-switchHeader': {
      marginTop: '0',
    },
    '& .MuiPickersCalendarHeader-daysHeader': {
      borderBottom: '1px solid #0000001f',
      paddingBottom: '25px',
    },
    '& .MuiTypography-root': {
      color: '#444C63',
      fontFamily: 'Lato',
      fontSize: '18px',
    },
    '& .MuiPickersCalendarHeader-dayLabel': {
      color: '#4860CF',
      fontFamily: 'Lato',
      fontSize: '12px',
      textTransform: 'uppercase',
      margin: 0,
    },
    '& .MuiPickersStaticWrapper-staticWrapperRoot': {
      minWidth: 'auto',
      '& .MuiPickersBasePicker-pickerView': {
        minWidth: '100%',
        maxWidth: '100%',
      },
    },
  },
  modalContainer: {
    // zIndex: '1350 !important',
    zIndex: '950 !important',
    '& .MuiDialogTitle-root': {
      padding: theme.spacing(2),
      '& .MuiTypography-h6': {
        borderBottom: '1px solid #BBBBBB',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        '& .MuiTypography-body1': {
          fontSize: '21px',
          fontWeight: 'bold',
          fontStyle: 'normal',
          color: '#4D507B',
          paddingBottom: theme.spacing(1),
        },
        '& .MuiDialogActions-root': {
          padding: theme.spacing(0),
        },
      },
    },
    '& .MuiDialogContent-root': {
      padding: theme.spacing(2),
      paddingTop: theme.spacing(0),
    },
    '& .MuiDialogActions-root': {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(3),
      paddingRight: theme.spacing(2),
      paddingLeft: theme.spacing(2),
    },
  },
  modalContainer1: {
    zIndex: '1350 !important',
    '& .MuiDialogTitle-root': {
      padding: theme.spacing(2),
      '& .MuiTypography-h6': {
        borderBottom: '1px solid #BBBBBB',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        '& .MuiTypography-body1': {
          fontSize: '21px',
          fontWeight: 'bold',
          fontStyle: 'normal',
          color: '#4D507B',
        },
        '& .MuiDialogActions-root': {
          padding: theme.spacing(0),
        },
      },
    },
    '& .MuiDialogContent-root': {
      padding: theme.spacing(2),
      paddingTop: theme.spacing(0),
    },
    '& .MuiDialogActions-root': {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(3),
      paddingRight: theme.spacing(2),
      paddingleft: theme.spacing(2),
    },
  },
  addInstructorModal: {
    zIndex: '1300 !important',
  },
  dailogStyle: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    borderBottom: '1px solid #BBBBBB',
  },
  dialogTitleStyle: {
    justifyContent: 'center',
  },
  dailogtitle: {
    fontSize: 21,
    color: '#4D507B',
    padding: theme.spacing(2),
    lineHeight: '21px',
  },
  buttonArrow: { padding: 0, minWidth: 10 },
  day: {
    width: '14%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  colwrapper: {
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      overflowX: 'auto',
      width: '100%',
    },
  },
  calHeading: { minWidth: '100%' },
  popupStyle: {
    zIndex: '910 !important',
    '& .MuiPopover-paper': {
      width: 640,
    },
    '& .Mui-disabled': {
      cursor: 'not-allowed',
    },
    [theme.breakpoints.down('xs')]: {
      '& .MuiTypography-h4': {
        fontSize: '16px',
      },
    },
  },
  popupIndicator: {
    color: '#4860CF',
  },
  listbox: {
    '& [data-option-index]': {
      paddingLeft: '12px !important',
    },
  },

  hideDash: { '& input:not(:focus)': { color: 'transparent' } },
  periodOfTime: {
    '& label': {
      whiteSpace: 'nowrap !important',
    },
  },
  buttonProgressWrapper: {
    position: 'relative',
    display: 'inline-block',
  },
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  /* studio styling start */
  headingContainer: {
    paddingLeft: 16,
    paddingRight: 16,
  },
  fontGrey: {
    fontSize: 18,
    color: '#353755',
  },
  selectHeadingBtn: {
    fontSize: 17,
    fontWeight: 800,
    color: '#4860CF',
  },
  addLinkButoon: {
    border: '1px solid #B0B5C4',
    textTransform: 'none',
    fontSize: '14px',
    padding: '6px 12px',
    '& .MuiButton-label': {
      fontWeight: '600',
    },
  },
  selectHeading: {
    fontSize: 18,
    fontWeight: 700,
    color: '#96A1BC',
  },
  borderLeft: {
    borderLeft: '2px solid #bbbbbb',
  },
  dividerstyle: {
    borderLeft: '2px solid #bbb',
    height: '20px',
    marginLeft: '-5px',
    marginTop: '15px',
  },
  studioListBox: {
    '& li .MuiAutocomplete-groupLabel': {
      display: 'none',
    },
    '& li:first-child .MuiAutocomplete-groupLabel': {
      display: 'block',
    },
  },
  /* studio styling end */
  loaderWrapper: {
    position: 'relative',
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(0.5),
      marginBottom: theme.spacing(0.5),
    },
  },
  errorAlignment: {
    '& p.MuiFormHelperText-root.Mui-error': {
      position: 'absolute',
      bottom: -21,
    },
  },
  repeatLabel: {
    textTransform: 'none',
    fontSize: 15,
  },

  classmodalouter: {
    zIndex: '900 !important',
    [theme.breakpoints.down('xs')]: {
      left: '3px !important',
      padding: '10px',
    },
  },
  classmodal: {
    width: 480,
    border: '4px solid #4860CF',
    [theme.breakpoints.down('xs')]: {
      width: 'auto',
    },
  },
  seatsleftlabel: {
    background: 'rgba(163,175,231,0.27)',
    borderRadius: '0 125px 125px 0',
    fontSize: 18,
    fontWeight: 700,
    color: '#353755',
    padding: '8px 15px',
    display: 'inline-block',
  },
  modalcancel: {
    fontSize: 14,
    fontWeight: 700,
    color: '#4860CF',
    padding: '8px',
  },
  modalcontent: {
    padding: '15px',
  },
  ClassDetailTitle: {
    color: '#4d507b',
  },
  modaldelete: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    fontSize: 12,
    fontWeight: 400,
    color: '#4860CF',
  },
  modaldate: {
    fontSize: 16,
    fontWeight: 700,
    color: '#353755',
  },
  modaltime: {
    fontSize: 16,
    fontWeight: 400,
    color: '#353755',
  },
  modaliconbox: {
    fontSize: 16,
    fontWeight: 400,
    color: '#353755',
    display: 'flex',
    alignItems: 'center',
  },
  modaliconboxTrial: {
    fontSize: 16,
    fontWeight: 400,
    color: '#353755',
    display: 'flex',
    alignItems: 'center',
    background: 'rgba(237, 239, 242, 1)',
    padding: '5px 10px',
    borderRadius: '50px',
  },
  modalicon: {
    marginRight: '10px',
    '& path': {
      fill: '#4860CF',
    },
  },
  modaltitle: {
    fontSize: 18,
    fontWeight: 700,
    color: '#353755',
  },
  modaldescription: {
    fontSize: 16,
    fontWeight: 400,
    color: '#353755',
    wordWrap: 'break-word',
  },
  modalinstructorbox: {
    fontSize: 16,
    fontWeight: 700,
    color: '#353755',
    display: 'flex',
    alignItems: 'center',
    marginBottom: '8px',
  },
  modalinstructorimg: {
    marginRight: '10px',
  },
  modalsignupbtn: {
    color: '#fff',
    fontSize: 16,
    padding: '5px 30px',
    margin: '10px 5px',
  },
  sessiontext: {
    fontSize: 16,
    fontWeight: 400,
    color: '#353755',
  },
  /*  */
  classDetailPosition: {
    position: 'absolute',
    left: 0,
    top: 95,
  },
  full: {
    background: '#f95759',
    width: 150,
    color: '#fff',
  },
  btnIcon: {
    textTransform: 'capitalize',
  },
  img: {
    maxWidth: 250,
  },
  closeBtn: { float: 'right', top: 15, right: -15 },
  checkContainer: {
    top: 5,
    right: 5,
    position: 'absolute',
    [theme.breakpoints.down('md')]: {
      top: 0,
      right: 0,
    },
  },
  classFull: {
    borderRadius: '50%',
    width: '21px',
    height: '21px',
    padding: '1px',
    background: '#be231f',
    color: 'white',
    textAlign: 'center',
    marginTop: '2px',
  },
  greenCheck: {
    color: '#06B346',
    fontSize: '24px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '16px',
    },
  },
  blueIcon: {
    color: '#4860CF',
  },
  check: {
    color: '#06B346',
    marginLeft: theme.spacing(0.5),
    fontSize: '34px',
    top: 13,
    position: 'absolute',
  },
  invalidPack: {
    fontSize: 21,
    textAlign: 'center',
    marginBottom: 41,
    marginTop: 20,
    lineHeight: '40px',
  },
  invalidPackBtn: { paddingLeft: 35, paddingRight: 35, marginBottom: 20 },
  h1: {
    color: '#4860CF',
    fontSize: 24,
    fontWeight: 700,
    marginBottom: 10,
  },
  packageHeader: {
    color: '#4860CF',
    fontSize: 16,
    fontWeight: 700,
    marginBottom: 10,
  },
  zoomLink: {
    display: 'inline-block',
    backgroundColor: 'rgba(14, 114, 237)',
    color: 'rgb(255, 255, 255)',
    lineHeight: 2,
    fontWeight: 500,
    fontSize: 14,
    borderWidth: 0,
    borderStyle: 'initial',
    borderColor: 'initial',
    borderImage: 'initial',
    padding: '1px 10px',
    borderRadius: 4,
  },
  direction: {
    height: '3rem',
    width: 'max-content',
    padding: '0px 0.8rem',
    background: 'rgb(255, 255, 255)',
    borderRadius: '0.4rem',
    border: '1px solid rgb(156, 156, 156)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    marginLeft: '10px',
    left: 0,
    color: 'rgb(0 0 0 / 78%)',
  },
  StudioAddress: {
    flex: 1,
  },
  '& .GoogleMapUI div div ': {
    display: 'flex',
    flexDirection: 'row-reverse',
  },
  GoogleMapUI: {
    '& +div ': {
      '& +div ': {
        display: 'flex',
        flexDirection: 'row-reverse',
      },
    },
  },
  /* GoogleSearchWrapper: {
    position: 'relative',
    display: 'inline-block',
    width: '100%',
    '& label': {
      color: '#4860CF',
      fontSize: '16px',
      fontWeight: '700',
    },
    '& input': {
      backgroundColor: 'transparent',
      border: 'none',
      outline: 'none',
      width: '100%',
      color: '#353755',
      fontSize: '18px',
      fontWeight: '400',
      padding: 0,
      paddingTop: '3px',
      paddingBottom: '3px',
      borderBottom: '2px solid #bbbbbb',
      '&:focus + span': {
        width: '100%',
      },
    },
  },
  underline: {
    position: 'absolute',
    bottom: 0,
    // to center the animation
    left: '50%',
    transform: 'translateX(-50%)',
    height: '2px',
    width: 0,
    backgroundColor: '#4860CF',
    transition: '.2s',
  }, */
  SelectClassTypeWrapper: {
    '& label': {
      color: '#4860CF',
      fontSize: '16px',
      fontWeight: '700',
    },
  },
  LocationSearchWrapper: {
    '& label': {
      color: '#4860CF',
      fontSize: '16px',
      fontWeight: '700',
    },
  },
  LocationSearch: {
    position: 'relative',
    marginTop: '5px',
    '& input': {
      background: '#F9F9FA',
      border: '1px solid #D8D8D8',
      borderRadius: '8px',
      height: '40px',
      width: '100%',
      padding: '8px 30px 8px 8px',
      color: '#353755',
      fontSize: '16px',
      '&:focus': {
        outline: '1px solid #4860CF',
      },
    },
    '& img': {
      position: 'absolute',
      right: '10px',
      top: '12px',
    },
  },
  UpcomingSessionsLink: {
    fontFamily: 'Lato',
    fontSize: '16px',
    color: '#353755',
    cursor: 'pointer',
    textDecoration: 'underline',
    '&:hover': {
      color: '#4860CF',
    },
  },
  IconOuter: {
    color: '#4860CF',
    borderRadius: '100px',
    background: '#E2E9FD',
    padding: '5px',
  },
  ABPDirections: {
    '& a': {
      border: '1px solid rgba(176, 181, 196, 1)',
      padding: '8px 16px 8px 8px',
      borderRadius: '8px',
      fontFamily: 'Lato',
      fontWeight: '600',
      fontSize: '16px',
      color: '#4860CF',
      cursor: 'pointer',
      display: 'inline-flex',
      alignItems: 'center',
      '& img': {
        borderRadius: '50%',
        border: '1px solid',
        marginRight: '10px',
      },
    },
  },
  SponsorImageBox: {
    // border: '1px solid #353755',
    borderRadius: '8px',
    width: '100px',
    height: '100px',
    padding: '5px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& img': {
      objectFit: 'cover',
      maxWidth: '100%',
      maxHeight: '100%',
      objectPosition: 'center',
    },
  },
  MainImageBox: {
    // border: '1px solid #353755',
    borderRadius: '8px',
    width: '200px',
    height: '200px',
    padding: '5px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& img': {
      objectFit: 'cover',
      maxWidth: '100%',
      maxHeight: '100%',
      objectPosition: 'center',
    },
  },

  ExpandIcon: {
    color: '#4860cf',
    cursor: 'pointer',
    fontSize: '22px',
    marginTop: '-2px',
    position: 'absolute',
  },

  ShowMore: {
    color: '#4860cf',
    cursor: 'pointer',
  },
  caltitlebox: {
    flexDirection: 'column',
    '@media (max-width:560px)': {
      flexDirection: 'inherit',
    },
  },
  AutoList: {
    width: '100%',
  },
  AutoDivider: {
    marginBottom: '15px',
  },
  LinksAddedBox: {
    '& ul': {
      padding: '0 0 0 18px',
      margin: 0,
    },
    '& ul li': {
      /* display: 'flex',
      alignItems: 'center', */
    },
    '& ul li a': {
      fontSize: '18px',
      textDecoration: 'underline',
    },
    '& ul li svg': {
      width: '18px',
      height: '18px',
      marginLeft: '10px',
      cursor: 'pointer',
    },
  },
  addLinkHelper: {
    fontSize: '12px',
    marginTop: '0px',
  },
  paddedGrid: {
    paddingTop: '5px',
  },
  /* eslint-disable prefer-template */
  AutoCompleteOptionHightlight: {
    '&[aria-selected="true"]': {
      backgroundColor: theme.palette.action.selected + ' !important',
    },
    '&:hover': {
      backgroundColor: theme.palette.action.hover + ' !important',
    },
    '&:focus': {
      backgroundColor: theme.palette.action.selected + ' !important',
      outline: 'none',
    },
    '&[data-focus="true"]': {
      backgroundColor: theme.palette.action.hover + ' !important',
    },
  },
}));

export default useStyles;
